import { GEO_FENCE_BLOCKED_KEY } from "@constants";

export const getCookieValue = (key: string): string | null => {
  if (typeof document === "undefined") return null;

  const escaped = key.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const isGeoRestrictedFromCookie = (cookieKey = GEO_FENCE_BLOCKED_KEY): boolean => {
  const value = getCookieValue(cookieKey)?.trim().toLowerCase();
  if (!value) return false;
  return value === "1" || value === "true";
};
